import { useTranslation } from 'react-i18next';
import {
  ARCHIVED_STATUS,
  ENABLED_STATUS,
  PAUSED_STATUS,
} from 'features/advertising/utils/constants';

const UpdateStatus = ({ data, onChangeData, errors }) => {
  const { t } = useTranslation();
  const onChange = (e) => {
    let newData = { ...data, state: e.target.value };
    onChangeData(newData);
  };

  return (
    <div className="mt-4">
      <label
        htmlFor="state"
        className="block text-tiny font-bold text-grayscale-700 font-medium tracking-3/4"
      >
        {t('Advertising.Common.Status')}
      </label>
      <div className="mt-1">
        <select
          id="state"
          name="state"
          className="py-3.5 border-0 bg-grayscale-400 block w-full rounded-2xl border-gray-300 px-3 focus:outline-none focus:ring-0 appearance-none focus:appearance-none text-mini placeholder-grayscale-600 text-grayscale-900"
          value={data.state}
          onChange={onChange}
        >
          <option value="">
            {t('Advertising.Rule.Action.UpdateStatus.SelectStatus')}
          </option>
          <option value={ENABLED_STATUS}>
            {t('Advertising.Rule.Action.UpdateStatus.Enabled')}
          </option>
          <option value={PAUSED_STATUS}>
            {t('Advertising.Rule.Action.UpdateStatus.Paused')}
          </option>
          <option value={ARCHIVED_STATUS}>
            {t('Advertising.Rule.Action.UpdateStatus.Archived')}
          </option>
        </select>
        {errors['actionData.state'] && (
          <p className="text-10 font-medium tracking-3/4 font-inter text-error-dark">
            {errors['actionData.state']}
          </p>
        )}
      </div>
    </div>
  );
};

export default UpdateStatus;
